/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CloudStorageCosts,
    CloudStorageCostsFromJSON,
    CloudStorageCostsFromJSONTyped,
    CloudStorageCostsToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetCloudAccountCostsResponse
 */
export interface GetCloudAccountCostsResponse {
    /**
     * 
     * @type {CloudStorageCosts}
     * @memberof GetCloudAccountCostsResponse
     */
    thisMonth: CloudStorageCosts | null;
    /**
     * 
     * @type {CloudStorageCosts}
     * @memberof GetCloudAccountCostsResponse
     */
    lastMonth: CloudStorageCosts | null;
}

export function GetCloudAccountCostsResponseFromJSON(json: any): GetCloudAccountCostsResponse {
    return GetCloudAccountCostsResponseFromJSONTyped(json, false);
}

export function GetCloudAccountCostsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCloudAccountCostsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'thisMonth': CloudStorageCostsFromJSON(json['this_month']),
        'lastMonth': CloudStorageCostsFromJSON(json['last_month']),
    };
}

export function GetCloudAccountCostsResponseToJSON(value?: GetCloudAccountCostsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'this_month': CloudStorageCostsToJSON(value.thisMonth),
        'last_month': CloudStorageCostsToJSON(value.lastMonth),
    };
}


